import store from "../../../store";
import {
  CABINET_FILTER_NAMES,
  END_CAP_AREA_PART_IDS,
  END_CAP_CABINETS_PART_IDS,
  END_CAP_PART_IDS, SHAPE_PART_ID, SIDEBAR_NAVIGATION_BUTTONS,
  SQFT_AREA_TYPE_PART_IDS, SQFT_FEATURES,
  SQFT_GROUP
} from "../constants";
import {getUrlSQFTHashParam} from "./sqftHelper";
import sqftConfig from "../components/canvas/store/sqftConfig";
import { SIDEBAR_NAVIGATION_CABINET_BUTTONS, SQFT_APPLIANCES } from "../constants";
import endCapCanvas from "../components/canvas/core/controls/endCapCanvas";
import {setSelectedFeature, setSelectedHandle, setSelectedHinge} from "../../../actions/sqftResourceFunctions";
import {
  setSelectedCountertop,
  setSelectedWall,
  setSQFTPopup
} from "../../../actions/sqftMenuFunctions";
import SqftOptionsHandlesContent
  from "../components/navigation/menu/cabinet/toolMenu/toolHandles/SqftOptionsHandlesContent";
import workspace from "../components/canvas/core/workspace";
import {closeSQFTPopup} from "../components/canvas/core/controls/resourseCanas";
import React from "react";

export const getSQFTGroupFromUrl = () => {
  return getUrlSQFTHashParam("group")
}

/**
 * Is SQFT in Area Group TYPE
 */
export const getIsSFTAreaGroup = () => {
  const isSFTAreaGroupInUrl = getSQFTGroupFromUrl();
  const {sqftState} = store.getState();
  const {sqftFromFeature} = sqftState;

  return isSFTAreaGroupInUrl || sqftFromFeature && (Object.keys(SQFT_AREA_TYPE_PART_IDS).includes(sqftFromFeature.cartFeature.partId));
}

/**
 * Is SQFT in Cabinets Group TYPE
 */
export const isSFTCabinetsGroup = () => {
  const isCabinetGroupInURL = sqftConfig.isCabinetGroupInURL();
  const {sqftState} = store.getState();
  const {SQFTGroup} = sqftState;

  return isCabinetGroupInURL || SQFTGroup === SQFT_GROUP.cabinets;
}

/**
 * Is SQFT Group Type
 */
export const getSQFTGroup = () => {
  const isSFTAreaGroupInUrl = getSQFTGroupFromUrl();
  const {sqftState} = store.getState();
  const {SQFTGroup} = sqftState;

  if (isSFTAreaGroupInUrl) {
    return isSFTAreaGroupInUrl
  }

  if (SQFTGroup) {
    return SQFTGroup;
  }

  return SQFT_GROUP.default
}

export const getPartIdsFromMenuOpened = (menuOpened) => {
  let partIds = menuOpened ? [menuOpened] : [];
  if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.centerIsland) {
    partIds = ['countertop'];
  } else if (menuOpened === SQFT_APPLIANCES.refrigerator) {
    partIds = ['fridge'];
  } else if (menuOpened === SQFT_APPLIANCES.stovetop) {
    partIds = ['stove'];
  } else if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel) {
    partIds = END_CAP_CABINETS_PART_IDS;
  } else if (menuOpened === SIDEBAR_NAVIGATION_BUTTONS.end_cap) {
    partIds = END_CAP_AREA_PART_IDS;
  } else if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.wall) {
    partIds = [SQFT_FEATURES.front_wall];
  } else if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.handles) {
    partIds = [SQFT_FEATURES.top_handle];
  }

  return partIds;
};

export const getSearchTextFromMenuOpened = (menuOpened) => {
  let searchText = "";
  if (menuOpened === SIDEBAR_NAVIGATION_CABINET_BUTTONS.end_panel) {
    searchText = "";//'End Panel';
  }
  return searchText;
};

export const getItemClickCallbackForPartId = (partId) => {
  let itemClickCallback = new Function();
  if (END_CAP_PART_IDS.includes(partId)) {
    itemClickCallback = (e, feature) => {
      endCapCanvas.setHighlighting(false);
      endCapCanvas.setCursorImage();
      store.dispatch(setSelectedFeature(feature));
    };
  } else if (partId === SHAPE_PART_ID.countertop) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedCountertop(feature.dbFeature.id));
    }
  } else if (partId === SHAPE_PART_ID.front_wall) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedWall(feature.dbFeature.id));
    }
  } else if (partId === SQFT_FEATURES.hinge) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedHinge(feature.dbFeature.id));

      const shapes = workspace.getShapesWithoutAttachedResources();
      for (const shape of shapes) {
        shape.shapeCabinet.deleteAttachedFeatures(CABINET_FILTER_NAMES.hinges);
        shape.shapeCabinet.generateAttachedFeatures(CABINET_FILTER_NAMES.hinges);
      }
    }
  } else if (partId === SQFT_FEATURES.top_handle) {
    itemClickCallback = (e, feature) => {
      store.dispatch(setSelectedHandle(feature));
      store.dispatch(setSQFTPopup(
        {
          title: workspace.intl.formatMessage({id: "sqft.popup.title.applyHandlesTo"}),
          content: <SqftOptionsHandlesContent handlePartId={feature.partId}/>,
          isOpened: true,
          confirmCallback: () => {
            const reduxState = store.getState();
            const selectedPartIds = reduxState.sqftResourceState.selectedPartIds
            const shapes = workspace.getShapesWithoutAttachedResources();
            const selectedShapes = shapes.filter(shape => selectedPartIds.includes(shape.partId));
            for (const selectedShape of selectedShapes) {
              selectedShape.shapeCabinet.deleteAttachedFeatures();
              selectedShape.shapeCabinet.generateAttachedFeatures();
            }
            closeSQFTPopup();
          },
          confirmText: workspace.intl.formatMessage({id: "sqft.popup.button.generate"}),
          cancelCallback: closeSQFTPopup,////closePopup,
          cancelText: workspace.intl.formatMessage({id: "sqft.popup.button.cancel"}),
        }
      ));
    }
  }

  return itemClickCallback;
};
